import store from '../../store/store'
import axiosHeaderMethods from './change-axios-header'
export default {
  setToken(token){
    axiosHeaderMethods.setTokenInOptionAxios(token)
    localStorage.setItem('user-token', token)
    store.commit('updateGuest')
  },
  setTokenWithoutBearer(token){
    axiosHeaderMethods.setTokenWithoutBearerInOptionAxios(token)
    localStorage.setItem('user-token', token)
    store.commit('updateGuest')
  },
  removeToken(){
    axiosHeaderMethods.removeTokenInOptionAxios()
    console.log('removeToken()')
    localStorage.removeItem('user-token')
    store.commit('updateGuest')
    store.commit('changeIsActiveOrders', false)
  }
}


// WEBPACK FOOTER //
// ./src/Unit/set-login-and-logout-parameters.js